export default __webpack_public_path__ + "img/catIcon689.5c8380dd.svg";